module.exports = __webpack_public_path__ + "img/icon-coin.0165abbe.png";